// @ts-nocheck
import {Column} from 'react-table'
import {FieldCodeCell} from './FieldCodeCell'
import {FieldDescCell} from './FieldDescCell'
// import {EnterpriseLastLoginCell} from './EnterpriseLastLoginCell'
// import {EnterpriseTwoStepsCell} from './EnterpriseTwoStepsCell'
import {FieldActionsCell} from './FieldActionsCell'
//import {EnterpriseSelectionCell} from './EnterpriseSelectionCell'
import {FieldCustomHeader} from './FieldCustomHeader'
import {FieldAbbreviateCell} from './FieldAbbreviateCell'
import {Field} from '../../core/_models'

const fieldColumns: ReadonlyArray<Column<Field>> = [
  {
    Header: (props) => (
      <FieldCustomHeader
        tableProps={props}
        title='FIELD.INPUT_PRODUCTION_DEMO_CODE'
        className='fs-8 min-w-auto text-center flex-row-fluid flex-center'
      />
    ),
    id: 'code',
    Cell: ({...props}) => <FieldCodeCell field={props.data[props.row.index]} />,
  },
  {
    Header: (props) => (
      <FieldCustomHeader
        tableProps={props}
        title='COMMON.ABBREVIATION'
        className='fs-8 min-w-auto text-center flex-row-fluid flex-center'
      />
    ),
    id: 'abbreviate',
    Cell: ({...props}) => <FieldAbbreviateCell field={props.data[props.row.index]} />,
  },
  {
    Header: (props) => (
      <FieldCustomHeader
        tableProps={props}
        title='COMMON.INPUT_NAME'
        className='fs-8 min-w-auto text-center flex-row-fluid flex-center'
      />
    ),
    id: 'name',
    Cell: ({...props}) => <FieldDescCell field={props.data[props.row.index]} />,
  },
  {
    Header: (props) => (
      <FieldCustomHeader
        tableProps={props}
        title='MENU.ACTIONS'
        className='fs-8 min-w-auto text-center flex-row-fluid flex-center'
      />
    ),
    id: 'actions',
    Cell: ({...props}) => <FieldActionsCell data={props.data[props.row.index]} />,
  },
]

export {fieldColumns}
